// generated from 4_588 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const locationFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("location_filter"),
  comparison_key: z.enum([
    "13", // 3_185 (69.42%)
    "14", // 1_000 (21.80%)
    "19", // 339 (7.39%)
    "18", // 64 (1.39%)
  ]),
  display_name: z.string(),
  // undefined: 1_756 (38.27%), defined 2_832 (61.73%)
  raw_value: z
    .object({
      // avg: 38.47, min: -42.882603, max: 69.666667
      lat: z.number(),
      latlngs: z.array(
        z.object({
          // avg: 41.41, min: -54.01394339228833, max: 75.39095903232936
          lat: z.number(),
          // integer: 5 (0.00%)
          // avg: -68.79, min: -168.0228424072266, max: 179.60174560546878
          lng: z.number(),
        })
      ),
      // avg: -36.95, min: -157.874521, max: 153.1151
      lng: z.number(),
      // integer: 1_384 (48.87%)
      // avg: 45091.03, min: 256, max: 4747842.552643739
      radius_in_meters: z.number().nonnegative(),
    })
    .optional(),
  value: z.object({
    // avg: 33.23, min: -42.882603, max: 69.666667
    lat: z.number(),
    latlngs: z.array(
      z.object({
        // avg: 41.22, min: -62.91523303947613, max: 75.39095903232936
        lat: z.number(),
        // integer: 5 (0.00%)
        // avg: -68.92, min: -179.04052, max: 179.60174560546878
        lng: z.number(),
      })
    ),
    // avg: -28.40, min: -157.874521, max: 176.16905
    lng: z.number(),
    // integer: 2_034 (44.33%)
    // avg: 47929.15, min: 212.96875790828744, max: 4747842.552643739
    radius: z.number().nonnegative(),
  }),
  varies_by_app_group: z.literal(false),
});
